/**
 * WorkspaceRoute Component
 * 
 * Wrapper for workspace routes that ensures SiteProvider remounts
 * when switching between workspaces to prevent stale data
 */

import { useParams } from "react-router-dom";
import { SiteProvider } from "@/lib/contexts/SiteContext";
import { URLStateProvider } from "@/lib/contexts/URLStateContext";
import { MapProvider } from "@/lib/contexts/MapContext";
import { FilterProvider } from "@/lib/contexts/FilterContext";
import DashboardLayout from "@/components/dashboard/DashboardLayout";

export function WorkspaceRoute() {
  const { workspaceId } = useParams<{ workspaceId: string }>();

  // Key SiteProvider to workspaceId so it remounts when workspace changes
  // This prevents stale currentSite data from persisting across workspace switches
  return (
    <SiteProvider key={workspaceId}>
      <FilterProvider>
      <URLStateProvider>
        <MapProvider>
          <DashboardLayout />
        </MapProvider>
      </URLStateProvider>
      </FilterProvider>
    </SiteProvider>
  );
}

